import { Injectable } from '@angular/core';

import { SgrResponse } from 'src/app/core/models/response.model';

@Injectable({
  providedIn: 'root',
})
export class AppLocalStorageService {
  private listeners: { [key: string]: (data: any) => void } = {};
  private eventListenerInitialized = false;

  constructor() {}

  private initEventListener(): void {
    if (!this.eventListenerInitialized) {
      window.addEventListener('storage', (event: StorageEvent) => {
        if (event.key && this.listeners[event.key]) {
          const data = event.newValue ? JSON.parse(event.newValue) : null;
          // Executa a callback registrada para a chave
          this.listeners[event.key](data);
          // Remove a chave do localStorage após a execução da callback
          setTimeout(() => localStorage.removeItem(event.key), 500);
        }
      });
      this.eventListenerInitialized = true;
    }
  }

  addListener(key: string, callback: (data: any) => void): void {
    this.listeners[key] = callback;
    // Inicializa o event listener se ainda não foi inicializado
    this.initEventListener();
  }

  removeListener(key: string): void {
    delete this.listeners[key];
  }

  setItem(key: string, data: any): void {
    switch (typeof data) {
      case 'string':
        localStorage.setItem(key, data);
        break;
      case 'number':
        localStorage.setItem(key, data.toString());
        break;
      case 'boolean':
        localStorage.setItem(key, data.toString());
        break;
      default:
        localStorage.setItem(key, JSON.stringify(data));
        break;
    }
  }

  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(param?: { keysToPreserve: string[] }): void {
    if (!param || param.keysToPreserve.length === 0) {
      localStorage.clear();
      return;
    }

    // Preserva valores das chaves especificadas
    const preservedData: { [key: string]: string } = {};

    param.keysToPreserve.forEach(key => {
      const value = localStorage.getItem(key);
      if (value !== null) {
        preservedData[key] = value;
      }
    });

    // Limpa tudo
    localStorage.clear();

    // Restaura os valores preservados
    Object.keys(preservedData).forEach(key => {
      localStorage.setItem(key, preservedData[key]);
    });
  }

  removeItems(keys: string[]): void {
    keys.forEach(key => {
      localStorage.removeItem(key);
    });
  }

  getAllKeys(): string[] {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        keys.push(key);
      }
    }
    return keys;
  }

  hasKey(key: string): boolean {
    return localStorage.getItem(key) !== null;
  }
}
